import Plan from '@square/dashboard-data/models/squareup/sub2/plan';
import Feature from '@square/dashboard-utilities/utils/sub2/feature';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  feature: attr(Feature),
  plan: attr(Plan),
  cancelWarning: attr(String),
  maintainDescription: attr(String),
  token: attr(String)
});